import * as React from 'react';
import { isAfter, isWithinInterval } from 'date-fns';
import { Alert, Summary, MediaQuery } from '@grandvisionhq/common';
import { Heading, Hr } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import PrescriptionInfoBar from '../PrescriptionInfoBar/PrescriptionInfoBar.js';
import PrescriptionTableContainer from '../PrescriptionTable/PrescriptionTableContainer.js';

const Prescription = ({ prescription  })=>{
    const { getLabel , getFormattedLabel , dateTime  } = useIntl();
    const { BreakpointName , useBreakpoint  } = MediaQuery;
    const breakpoint = useBreakpoint();
    const isMobile = breakpoint === BreakpointName.PHONE || breakpoint === BreakpointName.TABLET_PORTRAIT;
    const name = prescription.name || prescription.storeName;
    const { expiryDate , recommendedNextEyeTestDate  } = prescription;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, recommendedNextEyeTestDate && isRecommendedEyeTestDue(recommendedNextEyeTestDate, expiryDate) && /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        message: getFormattedLabel('account.prescription.eyeTestDue', {
            labelData: {
                date: dateTime.formatShortDate(new Date(expiryDate))
            },
            parseLink: false
        }),
        icon: "info"
    }), isPrescriptionExpired(expiryDate) && /*#__PURE__*/ React.createElement(Alert, {
        type: "warning",
        message: getLabel('account.prescription.prescriptionExpired'),
        icon: "warning"
    }), /*#__PURE__*/ React.createElement(Summary, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading2",
        component: "h2"
    }, name), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(PrescriptionInfoBar, {
        storeName: prescription.storeName,
        expiryDate: prescription.expiryDate
    }), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(PrescriptionTableContainer, {
        orientation: isMobile ? 'eyeSideTop' : 'eyeSideLeft',
        name: name,
        prescription: prescription
    })));
};
function isRecommendedEyeTestDue(eyeTestDate, expiryDate, todayDate = new Date()) {
    if (!eyeTestDate) {
        return false;
    }
    const dateEyeTestDate = new Date(eyeTestDate);
    const dateExpiryDate = new Date(expiryDate);
    if (isAfter(dateEyeTestDate, dateExpiryDate)) {
        return false;
    }
    return isWithinInterval(todayDate, {
        start: dateEyeTestDate,
        end: dateExpiryDate
    });
}
function isPrescriptionExpired(expiryDate, todayDate = new Date()) {
    return isAfter(todayDate, new Date(expiryDate));
}
var Prescription$1 = Prescription;

export { Prescription$1 as default, isPrescriptionExpired, isRecommendedEyeTestDue };
//# sourceMappingURL=Prescription.js.map
